import * as XLSX from "xlsx";

export interface ExportField {
    key: string;
    label: string;
}

function buildRows(
    data: Record<string, any>[],
    fields: ExportField[],
): Record<string, any>[] {
    return data.map((row) => {
        const out: Record<string, any> = {};
        fields.forEach(({ key, label }) => {
            out[label] = row[key] ?? "";
        });
        return out;
    });
}

export function exportToCSV(
    data: (Record<string, any> | null)[],
    fields: ExportField[],
    filename: string,
) {
    const rows = buildRows(data.filter(Boolean) as Record<string, any>[], fields);
    const headers = fields.map((f) => f.label);
    const csvLines = [
        headers.join(","),
        ...rows.map((row) =>
            headers
                .map((h) => {
                    const val = String(row[h] ?? "").replace(/"/g, '""');
                    return `"${val}"`;
                })
                .join(","),
        ),
    ];
    const blob = new Blob([csvLines.join("\n")], {
        type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}

export function exportToExcel(
    data: (Record<string, any> | null)[],
    fields: ExportField[],
    filename: string,
) {
    const rows = buildRows(data.filter(Boolean) as Record<string, any>[], fields);
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${filename}.xlsx`);
}
